import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import moment from "moment";
import ReactDatetime from "react-datetime";
import { Dna, Watch } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { getMarketing } from "stores";
// import ListMarketingByGetMarketing from "./ListMarketingByGetMarketing.1";

function ListKunjunganByGetMarketing(data) {
  // console.log(data, "KKKK");
  const dispatch = useDispatch();
  const kunjungan = useSelector((state) => state.kunjunganReducer);
  const auth = useSelector((state) => state.authReducer);
  const dataCabang = data.cabang;
  // console.log(dataCabang, "KKKK");

  const [isLoading, setIsLoading] = React.useState(true);
  const [tglAwal, setTglAwal] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [tglAkhir, setTglAkhir] = React.useState(new Date());
  const [idCabang, setIdCabang] = React.useState("");
  const [idMarketing, setIdMarketing] = React.useState("");
  const [listDataMarketing, setListDataMarketing] = React.useState([]);
  const [listDataCabang, setListDataCabang] = React.useState([]);
  const [sendKunjunganMarketing, setSendKunjunganMarketing] = React.useState(
    [],
  );
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleClick = () => {
    dispatch({ type: "SET_DETAIL_KUNJUNGAN_MARKETING", data: true });
  };

  React.useEffect(() => {
    let tmp =
      data.data &&
      data.data.map((val) => {
        // console.log(val, "VALLL");
        return {
          ...val,
          cabang: data.cabang,
          action: (
            <>
              {" "}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Detail</Tooltip>}
              >
                <Button
                  className="mr-0"
                  // variant="info"
                  style={{
                    marginTop: 5,
                    backgroundColor: "#F75D59",
                    border: 0,
                  }}
                  onClick={() => {
                    handleDetailsClick(val);
                  }}
                >
                  <i class="fas fa-info"></i>
                </Button>
              </OverlayTrigger>{" "}
            </>
          ),
        };
      });
    setListDataMarketing(tmp);
  }, [data.data]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const getHasil = (hasilNasabah) => {
    switch (hasilNasabah) {
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Pinjam":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      case "-":
        return {
          fontWeight: "bold",
          textColor: "#000000",
        };
      default:
        return {};
    }
  };

  const getKeputusan = (keputusan) => {
    switch (keputusan) {
      case "Tunda":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFE6CC",
          textColor: "#FF7F00",
        };
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Disetujui":
        return {
          fontWeight: "bold",
          backgroundColor: "#E4F5C9",
          textColor: "#87CB16",
        };
      case "Ditolak":
        return {
          fontWeight: "bold",
          backgroundColor: "#FF0000",
          textColor: "#FFE6E6",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    rows: {
      style: {
        height: 50, // override the row height
      },
    },
    headRow: {
      style: {
        minHeight: 35,
        backgroundColor: "#F8F8F8",
        // fontFamily: "Poppins",
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        minHeight: 50,
        fontWeight: "bold",
        fontSize: 14,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
    cells: {
      style: {
        minHeight: 50,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
  };

  const colKunjungan = [
    {
      name: "No",
      width: "100px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "Nama Nasabah",
      minWidth: "250px",
      center: true,
      selector: (row) => row.calonNasabah.namaNasabah,
    },
    {
      name: "Nama Nasabah",
      minWidth: "250px",
      center: true,
      selector: (row) => row.calonNasabah.typeKunjungan,
    },
    {
      name: "Tgl Lahir",
      minWidth: "150px",
      center: true,
      selector: (row) =>
        moment(row.calonNasabah.tglLahir).format("DD MMMM YYYY"),
    },
    {
      name: "Cabang",
      minWidth: "250px",
      center: true,
      selector: (row) => row.cabang.namaCabang,
    },
    {
      name: "Tgl Kunjungan",
      minWidth: "150px",
      center: true,
      selector: (row) => moment(row.tglKunjungan).format("DD MMMM YYYY"),
    },
    {
      name: "Plafond",
      minWidth: "180px",
      center: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.plafond);
        return formattedValue;
      },
    },
    {
      name: "Nett",
      minWidth: "180px",
      center: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.nett);
        return formattedValue;
      },
    },
    {
      name: "Keputusan",
      minWidth: "200px",
      center: true,
      selector: (row) => row.keputusan,
      cell: (row) => {
        const statusStyle = getKeputusan(row.keputusan);
        return (
          <div
            style={{
              fontWeight: statusStyle.fontWeight,
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {row.keputusan}
          </div>
        );
      },
    },
    {
      name: "Hasil",
      minWidth: "200px",
      center: true,
      selector: (row) => row.hasil,
      cell: (row) => {
        const hasil = row.hasil === "" ? "-" : row.hasil;
        const statusStyle = getHasil(hasil);
        return (
          <div
            style={{
              fontWeight: statusStyle.fontWeight,
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {hasil}
          </div>
        );
      },
    },
    // {
    //   name: "Aksi",
    //   minWidth: "200px",
    //   center: true,
    //   selector: (row) => row.action,
    // },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getMarketing(dispatch, {
      tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
      tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
      idCabang: idCabang,
      idMarketing: idMarketing,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [tglAwal, tglAkhir]);

  return (
    <>
      <Container fluid className="py-4">
        {/* TOP BAR: Back Button */}
        <Button
          className="btn-icon shadow-sm mb-4 d-flex align-items-center justify-content-center"
          style={{
            width: "42px",
            height: "42px",
            borderRadius: "12px",
            backgroundColor: "#fff",
            border: "1px solid #e2e8f0",
            color: "#F75D59",
          }}
          onClick={handleClick}
        >
          <i className="fas fa-arrow-left"></i>
        </Button>

        <Row>
          <Col md="12">
            <Card className="border-0 shadow-sm rounded-xl">
              <Card.Header className="bg-white border-0 pt-4 px-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h3
                      className="fw-800 text-dark m-0"
                      style={{ letterSpacing: "1px" }}
                    >
                      LIST KUNJUNGAN MARKETING
                    </h3>
                    <p className="text-muted small mb-0">
                      Pemantauan performa dan aktivitas kunjungan harian tim
                      marketing.
                    </p>
                  </div>
                  {/* Legend Badge */}
                  <div className="bg-light px-3 py-2 rounded-pill border">
                    <span className="text-muted fw-bold small">
                      <i className="fas fa-filter mr-2 text-primary"></i>
                      Filter Periode
                    </span>
                  </div>
                </div>

                {/* FILTER TOOLBAR: Compact Design */}
                <div className="bg-light p-3 rounded-xl border-0 mt-3 shadow-inner">
                  <Row className="align-items-end g-3">
                    <Col md={3} sm={6}>
                      <label className="text-muted small fw-bold uppercase mb-2 d-block ml-1">
                        Tanggal Awal
                      </label>
                      <div className="date-picker-wrapper shadow-sm rounded-lg bg-white p-1">
                        <ReactDatetime
                          inputProps={{
                            className: "form-control border-0 bg-transparent",
                            placeholder: "Pilih Tanggal",
                            readOnly: true,
                            style: {
                              cursor: "pointer",
                              fontWeight: "600",
                              color: "#334155",
                            },
                          }}
                          onChange={(e) => {
                            const date = e.toDate
                              ? e.toDate().setHours(0, 0, 0, 0)
                              : e;
                            setTglAwal(date);
                          }}
                          value={tglAwal}
                          timeFormat={false}
                          closeOnSelect={true}
                        />
                      </div>
                    </Col>

                    <Col md={3} sm={6}>
                      <label className="text-muted small fw-bold uppercase mb-2 d-block ml-1">
                        Tanggal Akhir
                      </label>
                      <div className="date-picker-wrapper shadow-sm rounded-lg bg-white p-1">
                        <ReactDatetime
                          inputProps={{
                            className: "form-control border-0 bg-transparent",
                            placeholder: "Pilih Tanggal",
                            readOnly: true,
                            style: {
                              cursor: "pointer",
                              fontWeight: "600",
                              color: "#334155",
                            },
                          }}
                          onChange={(e) => {
                            const date = e.toDate
                              ? e.toDate().setHours(0, 0, 0, 0)
                              : e;
                            setTglAkhir(date);
                          }}
                          value={tglAkhir}
                          timeFormat={false}
                          closeOnSelect={true}
                        />
                      </div>
                    </Col>

                    <Col md="auto" sm={12} className="ml-md-2 mt-3 mt-md-0">
                      <Button
                        className="px-4 fw-800 shadow-sm border-0"
                        style={{
                          backgroundColor: "#F75D59",
                          borderRadius: "10px",
                          height: "46px",
                          color: "white",
                        }}
                      >
                        <i className="fas fa-search mr-2"></i> LIHAT DATA
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Card.Header>

              <Card.Body className="px-4 pb-4 mt-2">
                {isLoading ? (
                  <div className="py-5 text-center d-flex flex-column align-items-center">
                    <Watch height="70" width="70" color="#F75D59" />
                    <h5 className="mt-4 fw-600 text-muted animate-pulse">
                      Memuat Aktivitas Marketing...
                    </h5>
                  </div>
                ) : listDataMarketing.length > 0 ? (
                  <div className="table-responsive-custom">
                    <DataTable
                      columns={colKunjungan}
                      data={listDataMarketing}
                      customStyles={customStyles}
                      pagination
                      paginationPerPage={itemsPerPage}
                      onChangePage={handlePageChange}
                      highlightOnHover
                      pointerOnHover
                    />
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <img
                      src={require("assets/img/sorry.jpg").default}
                      alt="Empty"
                      style={{ maxWidth: "180px", opacity: "0.8" }}
                    />
                    <h5 className="mt-4 fw-800 text-muted">
                      Belum ada kunjungan nasabah saat ini.
                    </h5>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <style>{`
    .fw-800 { font-weight: 800; }
    .rounded-xl { border-radius: 20px !important; }
    .rounded-lg { border-radius: 12px !important; }
    .shadow-inner { box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06); }
    
    /* Animation Pulse */
    @keyframes pulse {
      0% { opacity: 1; }
      50% { opacity: 0.5; }
      100% { opacity: 1; }
    }
    .animate-pulse { animation: pulse 2s infinite; }

    /* Custom Table Style */
    .rdt_Table { border: 1px solid #f1f5f9; border-radius: 15px; }
  `}</style>
      </Container>
    </>
  );
}

export default ListKunjunganByGetMarketing;
